import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrandStrong,
  colorLandingInk,
  colorLandingLine,
  colorLandingMuted,
  radiusLandingControl,
} from "src/design/tokens";

// Sample figures shown in the product mock — illustrative, not live data.
const STATS = [
  { labelKey: "landingPage.ecosystem.dashboard.bookings", value: "24", trend: "↗ +8%" },
  { labelKey: "landingPage.ecosystem.dashboard.covers", value: "78", trend: "↗ +5%" },
  {
    labelKey: "landingPage.ecosystem.dashboard.occupancy",
    value: "81%",
    trend: null,
    accent: true,
  },
];

/** The three KPI tiles at the top of the dashboard mock. */
export const DashboardStatsRow = () => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1.25} sx={{ mb: 1.75 }}>
      {STATS.map((stat) => (
        <Grid item xs={4} key={stat.labelKey}>
          <Box
            sx={{
              border: `1px solid ${colorLandingLine}`,
              borderRadius: radiusLandingControl,
              px: 1.5,
              py: 1.375,
              height: "100%",
            }}
          >
            <Typography sx={{ fontSize: 10, color: colorLandingMuted, lineHeight: 1.3 }}>
              {t(stat.labelKey)}
            </Typography>
            <Typography
              sx={{
                mt: 0.5,
                fontWeight: 800,
                fontSize: 22,
                letterSpacing: "-0.02em",
                color: stat.accent ? colorLandingBrandStrong : colorLandingInk,
              }}
            >
              {stat.value}
            </Typography>
            {stat.trend && (
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: 9.5,
                  fontWeight: 700,
                  color: colorLandingBrandStrong,
                }}
              >
                {stat.trend}
              </Typography>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
